import React, { useMemo, useState } from "react";
import "../login/login.css";
import { PCB_CORE_URL } from "../../config";
import { useNavigate, useParams } from "react-router-dom";

const API_RESET = `${PCB_CORE_URL}/reset-password/`;

export default function ResetPassword() {
  const { uidb64, token } = useParams();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [serverError, setServerError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const passwordsMatch = newPassword === confirmPassword;

  const canSubmit = useMemo(() => {
    return (
      newPassword.trim().length >= 6 &&
      confirmPassword.trim().length >= 6 &&
      passwordsMatch &&
      !loading
    );
  }, [newPassword, confirmPassword, passwordsMatch, loading]);

  async function handleSubmit(e) {
    e.preventDefault();
    setServerError("");
    setSuccessMsg("");
    if (!canSubmit) return;

    setLoading(true);
    try {
      const res = await fetch(API_RESET, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ uidb64, token, new_password: newPassword }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        const msg =
          data?.detail || data?.message || data?.Message || "Lien invalide ou expiré.";
        throw new Error(msg);
      }

      setSuccessMsg(data?.message || "Mot de passe réinitialisé avec succès.");
      setTimeout(() => navigate("/login", { replace: true }), 2000);
    } catch (err) {
      setServerError(err.message || "Erreur lors de la réinitialisation.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <h1 className="auth-title">Nouveau mot de passe</h1>
          <p className="auth-subtitle">Choisissez un nouveau mot de passe pour votre compte.</p>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          <label className="auth-label">
            Nouveau mot de passe
            <div className="pwd-row">
              <input
                className="auth-input"
                type={showPwd ? "text" : "password"}
                autoComplete="new-password"
                placeholder="Minimum 6 caractères"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                disabled={loading || !!successMsg}
                required
              />
              <button
                type="button"
                className="pwd-toggle"
                onClick={() => setShowPwd((v) => !v)}
                disabled={loading}
              >
                {showPwd ? "Masquer" : "Voir"}
              </button>
            </div>
          </label>

          <label className="auth-label">
            Confirmer le mot de passe
            <input
              className="auth-input"
              type={showPwd ? "text" : "password"}
              autoComplete="new-password"
              placeholder="Répétez le mot de passe"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              disabled={loading || !!successMsg}
              required
            />
          </label>

          {confirmPassword && !passwordsMatch ? (
            <div className="auth-alert error">Les mots de passe ne correspondent pas.</div>
          ) : null}

          {serverError ? <div className="auth-alert error">{serverError}</div> : null}
          {successMsg ? (
            <div className="auth-alert success">
              {successMsg} Redirection vers la connexion...
            </div>
          ) : null}

          {!successMsg && (
            <button className="auth-btn" type="submit" disabled={!canSubmit}>
              {loading ? "Réinitialisation..." : "Réinitialiser le mot de passe"}
            </button>
          )}

          <div className="auth-footer">
            <span>Retour à la</span>
            <a className="auth-link" href="/login">
              connexion
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}
